import { render, staticRenderFns } from "./imgDrawInline.vue?vue&type=template&id=5319ceb8&scoped=true"
import script from "./imgDrawInline.vue?vue&type=script&lang=js"
export * from "./imgDrawInline.vue?vue&type=script&lang=js"
import style0 from "./imgDrawInline.vue?vue&type=style&index=0&id=5319ceb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5319ceb8",
  null
  
)

export default component.exports